import type { GeneratedWorkbookJobsMessages } from './hooks/useGeneratedWorkbookJobs'

// ABP status copy shared by the OE tab upload section and the ABP Dashboard
// uploads list, so the dashboard util does not import from a component.
export const ABP5_GENERATION_FAILED_MESSAGE = 'Generation failed'
export const CONTRIBUTION_PROCESSING_FAILED_MESSAGE = 'Processing failed'
// EMS-11022 compact error copy (case #1 failed validation, case #3
// contribution model generated with errors).
export const INVALID_FILE_MESSAGE = 'This file is invalid.'
export const CONTRIBUTION_GENERATED_WITH_ERRORS_MESSAGE =
  'Contribution model generated with errors.'

export const FILE_INITIAL_REVIEW_UNAVAILABLE_MESSAGE =
  'File Initial Review is not available. Please upload it first'

// ABP-5 file job copy: the OE tab's toasts and the ABP Upload Dashboard's
// Generate banner (EMS-11146).
export const ABP5_FILE_MESSAGES: GeneratedWorkbookJobsMessages = {
  loadFailure: 'Failed to load ABP file jobs.',
  generateFailure: 'Failed to generate ABP file. Please try again.',
  downloadFailure: 'Failed to download ABP file. Please try again.',
  generateFailureByStatus: {
    409: 'An ABP file job is already in progress for this file.',
    422: FILE_INITIAL_REVIEW_UNAVAILABLE_MESSAGE,
  },
}
